import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Features } from './components/Features';
import { TargetAudience } from './components/TargetAudience';
import { ContentPreview } from './components/ContentPreview';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="font-sans text-brand-brown bg-brand-cream min-h-screen selection:bg-brand-rose/30 selection:text-brand-brown" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBar data-id="element-4" />
        <Features data-id="element-5" />
        <TargetAudience data-id="element-6" />
        <ContentPreview data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Guarantee data-id="element-9" />
        <Offer data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}